'use client';

import { memo } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Person, Phone } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

/**
 * Receiver details section
 */
const ReceiverSection = memo(({ receiverName, receiverPhone }) => {
  const { t } = useTranslation();
  if (!receiverName) return null;

  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        {t('bookingDetails.receiverDetails')}
      </Typography>
      <Stack spacing={1.5}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Person sx={{ fontSize: 18, color: 'action.active' }} />
          <Typography variant="body2">{receiverName}</Typography>
        </Stack>
        {receiverPhone && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Phone sx={{ fontSize: 18, color: 'action.active' }} />
            <Typography variant="body2">{receiverPhone}</Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
});

ReceiverSection.displayName = 'ReceiverSection';

export default ReceiverSection;
